import React, { useState } from "react";
import DataTable from "react-data-table-component";
import { Card, CardBody, Col } from "reactstrap";
import { RowCreateCallbackTitle } from "../../../../../constants";
import { RowCreateCallBackSubTitle, RowCreateCallBackTableColumns, RowCreateCallBackTableData } from "../../../../../data/formsAndTable/tables/dataTables/AdvanceInit";
import { RowCallBackItems } from "../../../../../types/Tables";
import FilterComponent from "../common/FilterComponent";
import CommonCardHeader from "../../../../../coreComponents/CommonCardHeader";

const RowCreateCallback = () => {
  const [filterText, setFilterText] = useState("");
  const filteredItems: RowCallBackItems[] = RowCreateCallBackTableData.filter((item: RowCallBackItems) => Object.values(item).some((value) => value && value.toString().toLowerCase().includes(filterText.toLowerCase())));
  return (
    <Col sm="12">
      <Card>
        <CommonCardHeader headClass="pb-0 card-no-border" title={RowCreateCallbackTitle} span={RowCreateCallBackSubTitle} />
        <CardBody>
          <FilterComponent onFilter={(e: React.ChangeEvent<HTMLInputElement>) => setFilterText(e.target.value)} filterText={filterText} />
          <div className="table-responsive">
            <DataTable data={filteredItems} columns={RowCreateCallBackTableColumns} striped={true} pagination className="display custom-scrollbar" />
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};
export default RowCreateCallback;
